<template>
  <div>
    <app-filter
      :filter-list="table_filter"
      @search="search"
    />
    <app-table
      ref="app-table"
      :table-key="table_key"
      :tablep="table_params"
      :page-size="15"
      :get-data="getTemplateList"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import TemplateResource from '@/api/template';
const templateResource = new TemplateResource();

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  props: {
    initConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      table_filter: require('./model/table-filter.js')(this),
      table_key: require('./model/table-key.js')(this),
      table_params: {
        page: 1,
        limit: 15,
      },
      // 行编辑表单配置
      form_data_config: {
        name: {
          name: {
            label: '模板名称',
            type: 'input',
            props: {
              placeholder: '请输入模板名称',
            },
            value: '',
          },
        },
      },
    };
  },
  computed: {
    /**
     * 渠道初始化配置数据
     * @returns {Object}
     */
    init_ops() {
      const { init_ops } = this.initConfig;
      return init_ops;
    },
  },
  methods: {
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs['app-table'].seekTable();
    },
    refer() {
      this.$refs['app-table'].refer();
    },
    /**
     * 模板置顶状态
     * @param {Object} row 模板列表项
     * @returns {void}
     */
    setTemplateTopStatus(row) {
      if (!row.is_lock) {
        if (row.top) {
          templateResource.cancelTemplatePointApi(row.id).then(() => {
            this.$refs['app-table'].seekTable();
          });
        } else {
          templateResource.setTemplatePointApi(row.id).then(() => {
            this.$refs['app-table'].seekTable();
          });
        }
      }
    },
    /**
     * 应用模板
     * @param {Object} row 模板列表项
     * @returns {void}
     */
    applicationTemplate(row) {
      this.$emit('confirm', row, this.initConfig);
    },
    /**
     * 删除模板
     * @param {Object} row 模板列表项
     * @returns {void}
     */
    onDeleteTemplate(row) {
      this.$confirm('是否删除当前已选中的模板？', row.name, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        templateResource.deleteTemplateApi(row.id).then(({ message }) => {
          this.$message.success(message || '删除成功');
          this.refer();
        });
      });
    },
    /**
     * 获取模板列表
     * @param {Object} params 接口参数
     * @returns {Promise}
     */
    getTemplateList(params) {
      return new Promise((resolve, reject) => {
        templateResource.getTemplateListApi({
          ...params,
          advertiser: this.init_ops.channel_interface,
          type: `${this.init_ops.channel_interface}_fusion_plans`,
        }).then((res) => {
          res.list = res.list.map(item => ({ ...item, is_lock: false }));
          resolve(res);
        }).catch(reject);
      });
    },
    /**
     * 编辑模板名称
     * @param {number} id 模板id
     * @param {Object} params 接口参数
     * @returns {Promise}
     */
    editTemplateName(id, params) {
      return new Promise((resolve, reject) => {
        templateResource.editTemplateName(id, params).then(({ message }) => {
          this.$message.success(message || '更新成功');
          this.refer();
          resolve();
        }).catch(reject);
      });
    },
    /**
     * 关闭表格所有的Popover
     * @returns {void}
     */
    closeAllTablePopover() {
      for (const key in this.$refs) {
        if (key.indexOf('table_el_popover_ref') !== -1) {
          this.$refs[key]?.doClose?.();
        }
      }
    },
  },
};
</script>
